<svg
    width="376"
    height="212"
    viewBox="0 0 376 212"
    xmlns="http://www.w3.org/2000/svg">
    <g
        app-roof
        [type]="type()"></g>

    <g
        transform="translate(35, -70)"
        [width]="300"
        [height]="300"
        app-roof-box></g>

    <g
        app-square-box
        [width]="200"
        [height]="200"
        [x]="-20"
        [y]="80"></g>

    <g
        app-square-box
        [width]="200"
        [height]="200"
        [x]="30"
        [y]="110"></g>

    <!-- <g app-catalog-icon [size]="200"/> -->
</svg>
